import { MultiStepForm } from '../components/registration';

export default function Registration() {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-slate-900 mb-2">Reunion Registration</h1>
        <p className="text-slate-600 mb-8">
          Complete the form below to register your family for the reunion.
        </p>
        <MultiStepForm />
      </div>
    </div>
  );
}
